const locked = (element: Element) => /hidden|clip/.test(getComputedStyle(element).overflowY)

/**
 * Keeps `--page-scrollbar` on <html> at the width of the page's own scrollbar (0 with overlay scrollbars or a page
 * that does not scroll), read only while the page is NOT scroll-locked, so a modal can take that strip for its own
 * scroller and pad the page by it (app.css, "A modal's scrollbar sits where the page's was"). Returns the cleanup.
 */
export function trackPageScrollbar(): () => void {
  const html = document.documentElement
  const update = () => {
    // Locked (base-ui's lock, or app.css handing the strip to a dialog), the width is no longer the page's own.
    if (locked(html) || locked(document.body)) return
    html.style.setProperty('--page-scrollbar', `${Math.max(0, window.innerWidth - html.clientWidth)}px`)
  }
  // The root's box narrows as its scrollbar appears and widens as it goes: exactly when the width changes. Its first
  // report, after the frame's own layout, is the initial read: reading here forced a whole-document style recalc.
  const observer = new ResizeObserver(update)
  observer.observe(html)
  window.addEventListener('resize', update)
  return () => {
    observer.disconnect()
    window.removeEventListener('resize', update)
  }
}
